import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Divider, DialogActions, ThemeProvider, Dialog, Typography} from '@material-ui/core'
import ButtonDefault from 'components/Button/ButtonDefault'
import theme from 'theme'
import useDialogComponentStyles from './styles'

type DialogComponentProps = {
  closeModal: (value: boolean) => void
  isOpen?: boolean
  withThemeProvider?: boolean
  title?: string
  subTitle?: string
  description?: string
}

const DialogComponent: React.FC<DialogComponentProps> = ({
  closeModal,
  isOpen = true,
  withThemeProvider = true,
  title,
  subTitle,
  description,
}) => {
  const {t} = useTranslation()
  const classes = useDialogComponentStyles()

  const Wrapper = withThemeProvider
    ? // eslint-disable-next-line react/no-unused-prop-types
      ({children}: {children: React.ReactNode}) => (
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      )
    : React.Fragment

  return (
    <Wrapper>
      <Dialog
        open={isOpen}
        onClose={() => closeModal(false)}
        data-test="router-confirmation-dialog"
        classes={{paper: classes.dialog}}
      >
        <Box className={classes.container}>
          <Typography data-test="dialog-title" variant="h2" className={classes.title}>
            {title || t('routerConfirmationDialog:title')}
          </Typography>
          <Typography data-test="dialog-sub-title" variant="h3" className={classes.subTitleExtra}>
            {subTitle || t('routerConfirmationDialog:youAreGoingToLeave')}
          </Typography>
          <Typography data-test="dialog-description" className={classes.description}>
            {description || t('routerConfirmationDialog:changesWillBeLost')}
          </Typography>
        </Box>
        <Divider classes={{root: classes.divider}} />
        <DialogActions classes={{root: classes.dialogButtonsWrapper}}>
          <ButtonDefault
            onClick={() => closeModal(false)}
            color="secondary"
            variant="contained"
            size="large"
            data-test="dialog-cancel-btn"
          >
            {t('btn:cancel')}
          </ButtonDefault>
          <ButtonDefault
            onClick={() => closeModal(true)}
            variant="contained"
            size="large"
            data-test="dialog-continue-btn"
          >
            {t('btn:continue')}
          </ButtonDefault>
        </DialogActions>
      </Dialog>
    </Wrapper>
  )
}

export default DialogComponent
